// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-login-container{
  /* max-width: 1440px; */


    width: 100%;
  height: 100vh;
  
   display: flex;
   flex-direction: column;
  justify-content: center;
  align-items: center;
 
}

.adminPanelMainDiv__login{
    display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #fff;
  min-height: calc(100vh - 134px);
}
.inputDivStyle-login{
  width: 368px;
}
.textDiv__login{
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: 50px;
}

.checkbox__i {
  border-radius: 4px;
  border: 1px solid #d5dce1;
  background: #fff;
  align-items: center;
}

.Remember__01 {
  color: #405261;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  margin-left: 8px;
}
.block__check {
  display: flex;
  justify-content: center;
  align-items: center;
}
.forget__passtext {
  color: #148dfd;
  text-align: right;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}
.sent__verification{
  color: #405261;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: normal;
}


.custom-checkbox {
  display: none;
}


.custom-checkbox + label {
  position: relative;
  padding-left: 20px; 
  cursor: pointer;
    align-items: center;
    bottom: 4px
}


.custom-checkbox + label::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
height: 18px;
border-radius: 4px;
border: 1px solid #D5DCE1;
background: #FFF;
box-sizing: border-box;
box-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.10);
}


.custom-checkbox + label::after {
  content: "✔"; 
  position: absolute;
  left: 0px; 
  top: 0.5px; 
  text-align: center;
color: #148DFD;
stroke-width: 1px;
border-radius: 4px;
border: 1px solid #148DFD;
width: 18px;
height: 18px;
  opacity: 0; /* Initially hidden */
  box-sizing: border-box;
flex-shrink: 0;
}


.custom-checkbox:checked + label::after {
  opacity: 1; 
}
@media screen and (max-width: 550px) {

  .textDiv {
    color: #5f44f7;
    margin: 0px 0px 0px 0px;
    font-size: 22px;
    margin-bottom: 25px;
  }
  .inputDivStyle-login{

    width: 100%;
    padding: 24px;
  }
  .footer__trust {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #777777;
    border: none;
    outline: none;
    /* padding: 10px 5px; */
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Login/style.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;;;IAGrB,WAAW;EACb,aAAa;;GAEZ,aAAa;GACb,sBAAsB;EACvB,uBAAuB;EACvB,mBAAmB;;AAErB;;AAEA;IACI,aAAa;EACf,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,iBAAiB;;EAEjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB;;;AAGA;EACE,aAAa;AACf;;;AAGA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;IACb,mBAAmB;IACnB;AACJ;;;AAGA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;AACb,YAAY;AACZ,kBAAkB;AAClB,yBAAyB;AACzB,gBAAgB;AAChB,sBAAsB;AACtB,oDAAoD;AACpD;;;AAGA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB,cAAc;AACd,iBAAiB;AACjB,kBAAkB;AAClB,yBAAyB;AACzB,WAAW;AACX,YAAY;EACV,UAAU,EAAE,qBAAqB;EACjC,sBAAsB;AACxB,cAAc;AACd;;;AAGA;EACE,UAAU;AACZ;AACA;;EAEE;IACE,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,mBAAmB;EACrB;EACA;;IAEE,WAAW;IACX,aAAa;EACf;EACA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,uBAAuB;EACzB;AACF","sourcesContent":[".main-login-container{\n  /* max-width: 1440px; */\n\n\n    width: 100%;\n  height: 100vh;\n  \n   display: flex;\n   flex-direction: column;\n  justify-content: center;\n  align-items: center;\n \n}\n\n.adminPanelMainDiv__login{\n    display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background: #fff;\n  min-height: calc(100vh - 134px);\n}\n.inputDivStyle-login{\n  width: 368px;\n}\n.textDiv__login{\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  margin-bottom: 50px;\n}\n\n.checkbox__i {\n  border-radius: 4px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  align-items: center;\n}\n\n.Remember__01 {\n  color: #405261;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  margin-left: 8px;\n}\n.block__check {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.forget__passtext {\n  color: #148dfd;\n  text-align: right;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n}\n.sent__verification{\n  color: #405261;\nfont-size: 12px;\nfont-style: normal;\nfont-weight: 400;\nline-height: normal;\n}\n\n\n.custom-checkbox {\n  display: none;\n}\n\n\n.custom-checkbox + label {\n  position: relative;\n  padding-left: 20px; \n  cursor: pointer;\n    align-items: center;\n    bottom: 4px\n}\n\n\n.custom-checkbox + label::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 18px;\nheight: 18px;\nborder-radius: 4px;\nborder: 1px solid #D5DCE1;\nbackground: #FFF;\nbox-sizing: border-box;\nbox-shadow: 0px 1px 2px 0px rgba(20, 141, 253, 0.10);\n}\n\n\n.custom-checkbox + label::after {\n  content: \"✔\"; \n  position: absolute;\n  left: 0px; \n  top: 0.5px; \n  text-align: center;\ncolor: #148DFD;\nstroke-width: 1px;\nborder-radius: 4px;\nborder: 1px solid #148DFD;\nwidth: 18px;\nheight: 18px;\n  opacity: 0; /* Initially hidden */\n  box-sizing: border-box;\nflex-shrink: 0;\n}\n\n\n.custom-checkbox:checked + label::after {\n  opacity: 1; \n}\n@media screen and (max-width: 550px) {\n\n  .textDiv {\n    color: #5f44f7;\n    margin: 0px 0px 0px 0px;\n    font-size: 22px;\n    margin-bottom: 25px;\n  }\n  .inputDivStyle-login{\n\n    width: 100%;\n    padding: 24px;\n  }\n  .footer__trust {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    color: #777777;\n    border: none;\n    outline: none;\n    /* padding: 10px 5px; */\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
